export const ipV4Pattern = "^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$";
export const ipV6Pattern = "^(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}$";